import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "layout-text-only-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21 6.7a.75.75 0 000-1.5H3a.75.75 0 100 1.5h18zM21 10.73a.75.75 0 000-1.5H3a.75.75 0 100 1.5h18zM21.75 14.02c0 .41-.33.75-.75.75H3a.75.75 0 010-1.5h18c.42 0 .75.34.75.75zM12 18.8a.75.75 0 000-1.5H3a.75.75 0 000 1.5h9z" }, null, -1)
  ])))
}
export default { render: render }